import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const closeConsolidation = {
  name: "closeConsolidation" as const,
  input: z.object({ consolidationId: consolidationIdFormat.schema }),
  output: z.object({ closedAt: z.date() }),
};
